import React from 'react';
import { Alert } from '@shared/components';
import { Select } from '@shared/components/form/Select';
import type { DerivedScheduleStartOption } from '../../../types/derivedSchedule.types';

interface StartServiceSelectProps {
    options: DerivedScheduleStartOption[];
    value: number | null;
    onChange: (index: number) => void;
    disabled?: boolean;
    truncationWarning?: string | null;
}

// Props in, callbacks out. Mounted above the Service Order list only when
// there is a real choice.
export const StartServiceSelect: React.FC<StartServiceSelectProps> = ({
    options,
    value,
    onChange,
    disabled = false,
    truncationWarning,
}) => {
    // Duplicate service names are valid within a plan, so the position is what
    // makes two same-named occurrences distinguishable.
    const selectOptions = options.map((option) => ({
        value: String(option.index),
        label: `Service ${option.position}: ${option.name}`,
    }));

    return (
        <div className="mb-4 space-y-2">
            <span className="block font-heading text-base font-semibold text-mp-foreground mb-1">Starting Service</span>
            <Select
                id="start-service-select"
                options={selectOptions}
                value={value !== null ? String(value) : undefined}
                onChange={(next) => onChange(Number(next))}
                disabled={disabled}
                ariaLabel="Starting Service"
                ariaDescribedBy={truncationWarning ? 'start-service-truncation-warning' : undefined}
            />
            {truncationWarning && (
                <Alert variant="warning">
                    <p id="start-service-truncation-warning">{truncationWarning}</p>
                </Alert>
            )}
        </div>
    );
};
